module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/PYBNAo/tc-custom/9780830853014.jpg?1696024558559",
      "alt": "This image is the cover for the book Does God Exist?"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Does God Exist?\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('strong', [_vm._v("Does God exist?")])]), _vm._v(" "), _c('p', [_vm._v("Throughout the history of philosophical and theological reflection, this fundamental question has prompted a range of responses.")]), _vm._v(" "), _c('p', [_vm._v("In one incisive volume, philosopher W. David Beck offers a narrative of pre-Christian, Jewish, Buddhist, Christian, and Islamic arguments for God's existence. Here, readers will encounter both classical and contemporary arguments, including cosmological, teleological, moral, and ontological arguments along with commentary from the author.")]), _vm._v(" "), _c('p', [_vm._v("Explore the history of answers to an essential question and add your own reflections to this ongoing conversation.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      W. David Beck\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("W. David Beck (PhD, Boston University) is emeritus professor of philosophy at Liberty University. He is the coeditor of "), _c('em', [_vm._v("Raised on the Third Day: Defending the Historicity of the Resurrection of Jesus")]), _vm._v(", and his written work has appeared in publications including "), _c('em', [_vm._v("Philosophia Christi")]), _vm._v(", "), _c('em', [_vm._v("Journal of the Evangelical Theological Society")]), _vm._v(", and "), _c('em', [_vm._v("Christianity Today")]), _vm._v(".")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    InterVarsity Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0